import React from "react";

import { useController, useFormContext } from "react-hook-form";
import { Card, CardContent, Typography } from "@mui/material";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.js";
import { OpeningHoursSettings } from "../../../../../Components/OpeningHours/OpeningHoursSettings.tsx";

function ProductTimeTable() {
  const { control } = useFormContext();
  const { field } = useController({ control, name: "opening_hours" });

  return (
    <Card>
      <CardContent>
        <Typography variant={"subtitle1"}>
          <TranslationWrapper tKey={"This category is visible at these times."} />
        </Typography>
        <OpeningHoursSettings<undefined>
          openingHours={field.value ?? {}}
          onChange={(openingHours) => field.onChange(openingHours)}
          open24Label={<TranslationWrapper tKey={"24H Available"} />}
          closedLabel={<TranslationWrapper tKey={"Never available"} />}
          emptyExtensionData={undefined}
        />
      </CardContent>
    </Card>
  );
}

export default ProductTimeTable;
